<template>
  <div>
    <!-- 导航 -->
      <home-header></home-header>
    <!-- banner -->
      <carousel-banner></carousel-banner>
    <!-- Handle检索 -->
      <handle-search></handle-search>
    <!-- 新闻 -->
      <news></news>
    <!-- 亮点介绍 -->
      <Advantage></Advantage>
    <!-- 地图 -->
      <home-map></home-map>
    <!-- 产品介绍 -->
      <products></products>
    <!-- 解决方案 -->
      <solution></solution>
    <!-- 合作伙伴 -->
      <Partner></Partner>

      <home-footer></home-footer>
  </div>
</template>

<script>
import HomeHeader from './../common/HomeHeader.vue'
import CarouselBanner from './components/CarouselBanner.vue'
import HandleSearch from './components/HandleSearch.vue'
import Products from './components/Products.vue'
import Advantage from './components/Advantage.vue'
import Solution from './components/Solution'
import homeMap from './components/map'
// import Service from './components/Service.vue'
import News from './components/news.vue'
import Partner from './components/Partner.vue'
import HomeFooter from '@/common/HomeFooter.vue'

export default {
  name: 'Home',
  components: {
    HomeHeader,
    CarouselBanner,
    HandleSearch,
    Products,
    Solution,
    homeMap,
    Advantage,
    // Service,
    Partner,
    News,
    HomeFooter
  }
}
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/Home/Home.vue